import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-33205520"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "button-follow"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }

import {onMounted, ref} from 'vue'
import { useAuth } from '@/store/useAuth'
import FollowRoadmapService from '@/services/FollowRoadmapService'
import {useToast} from '@/store/useToast'
import { Toast } from '@/interfaces/ToastInterface';
import main from '@/data/main.js';


export default /*#__PURE__*/_defineComponent({
  __name: 'FollowRoadmapWidget',
  props: ['roadmapId'],
  setup(__props) {

const props = __props
const store = useAuth()
const toast = useToast()
const follow = ref(false)
const loading = ref(true)
const followRoadmapService = new FollowRoadmapService()

onMounted(async () => {
    if(!store.token) {
        return;
    }
    follow.value = await followRoadmapService.checkFollowRoadmapStatus(store.token, props.roadmapId)
    loading.value = false
})

const handleFollowRoadmap = async () => {
    if(!store.token) {
        return;
    }
    loading.value = true
    const response = await followRoadmapService.doFollowToRoadmap(store.token, props.roadmapId)
    toast.showToast("Has comenzado a seguir este itinerario.", Toast.SUCCESS)
    setTimeout(function() {toast.hideToast()}, 4000);
    follow.value = true
    loading.value = false
}

const handleUnfollowRoadmap = async () => {
    if(!store.token) {
        return;
    }
    loading.value = true
    const response = await followRoadmapService.doUnfollowToRoadmap(store.token, props.roadmapId)
    toast.showToast("Has dejado de seguir este itinerario.", Toast.WARNING)
    setTimeout(function() {toast.hideToast()}, 4000);
    follow.value = false
    loading.value = false
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_unref(store).token)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (loading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_v_icon, {
                name: "ri-loader-2-fill",
                animation: "spin",
                class: "icon",
                scale: "2"
              })
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (follow.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "button-follow-inner",
                    onClick: handleUnfollowRoadmap
                  }, [
                    _createVNode(_component_v_icon, {
                      name: "bi-heart-fill",
                      fill: _unref(main).THIRD_COLOR,
                      hover: "true",
                      animation: "wrench",
                      class: "heart",
                      scale: "1"
                    }, null, 8, ["fill"]),
                    _createTextVNode(),
                    _createElementVNode("span", null, _toDisplayString(_unref(main).TITLE_BUTTON_FOLLOW_ROADMAP_WIDGET), 1)
                  ]))
                : (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: "button-follow-inner",
                    onClick: handleFollowRoadmap
                  }, [
                    _createVNode(_component_v_icon, {
                      name: "bi-heart-fill",
                      fill: "#ccc",
                      hover: "true",
                      animation: "wrench",
                      class: "heart",
                      scale: "1"
                    }),
                    _createTextVNode(),
                    _createElementVNode("span", null, _toDisplayString(_unref(main).TITLE_BUTTON_FOLLOW_ROADMAP_WIDGET_BEFORE), 1)
                  ]))
            ]))
      ]))
    : _createCommentVNode("", true)
}
}

})